module.exports = __webpack_public_path__ + "static/image-2-acc1759c02a7a2eb7598b93d0335171e.png";